// ============================================================
// KONTAKT PODRŠKE — jedino mesto gde se menjaju telefon, e-mail i radno vreme
// ============================================================
export const SUPPORT = {
  phone: '+381677114372',
  phoneDisplay: '+381 67 711 4372',
  email: 'podrska@finart.rs', // privremeno — zameniti pravim mejlom
  // Radno vreme po beogradskom vremenu: dani 1–5 (pon–pet), od 8 do 16 h
  days: [1, 2, 3, 4, 5],
  from: 8,
  to: 16,
};

// Da li je podrška trenutno dostupna (po vremenu u Beogradu)
export function isSupportOnline(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Belgrade', weekday: 'short', hour: 'numeric', hour12: false,
  }).formatToParts(now);
  const wd = parts.find((p) => p.type === 'weekday')?.value;
  const hour = Number(parts.find((p) => p.type === 'hour')?.value);
  const dayIdx = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 }[wd];
  return SUPPORT.days.includes(dayIdx) && hour >= SUPPORT.from && hour < SUPPORT.to;
}

// Otvara AI asistenta iz bilo kog dela aplikacije
export const openAssistant = () => window.dispatchEvent(new Event('finart:open-assistant'));
